export const getErrorMessage = (
  t: (key: string) => string,
  type: string,
  maxLength?: string
) => {
  switch (type) {
    case "required":
      return t("Errors:input_field_required");
    case "maxLength":
      return t("Errors:max_chars_exceeded").replace("{0}", maxLength ?? "");
    case "pattern":
      return t("Errors:regex_validation");
    case "validate":
      return t("Errors:InvalidAttributeValue");
    default:
      return null;
  }
};

export function filterAlternatives(
  query: string,
  alternatives: string[] = []
): string[] {
  return (alternatives ?? []).filter((element) =>
    element.toLowerCase().startsWith(query.toLowerCase())
  );
}

export function prettifyFreeTextInput(input: string): string {
  const result = input
    .replace(/\s*,?\s*\n/g, ",")
    .trim()
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean)
    .join(", ");
  return result === "" ? "" : result;
}
